if (!customElements.get('announcement-countdown')) {
  customElements.define(
    'announcement-countdown',
    class extends HTMLElement {
      connectedCallback() {
        this.hoursElement = this.querySelector('[data-countdown-hours]');
        this.minutesElement = this.querySelector('[data-countdown-minutes]');
        this.secondsElement = this.querySelector('[data-countdown-seconds]');
        this.duration = Math.max(1, Number(this.dataset.duration) || 60);
        this.storageKey = this.dataset.storageKey || `announcement-timer-${this.duration}`;
        this.deadline = this.readDeadline();
        this.tick();
        this.interval = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      readDeadline() {
        const now = Date.now();

        try {
          const stored = JSON.parse(window.localStorage.getItem(this.storageKey) || 'null');

          if (stored?.duration === this.duration && Number(stored.deadline) > now) {
            return Number(stored.deadline);
          }
        } catch (error) {
          // Storage is optional. The timer still works for the current page view.
        }

        return this.createDeadline(now);
      }

      createDeadline(now = Date.now()) {
        const deadline = now + this.duration * 1000;

        try {
          window.localStorage.setItem(
            this.storageKey,
            JSON.stringify({ duration: this.duration, deadline })
          );
        } catch (error) {
          // Storage is optional. The timer still works for the current page view.
        }

        return deadline;
      }

      tick() {
        const now = Date.now();

        if (now >= this.deadline) {
          const cyclesElapsed = Math.floor((now - this.deadline) / (this.duration * 1000)) + 1;
          this.deadline += cyclesElapsed * this.duration * 1000;

          try {
            window.localStorage.setItem(
              this.storageKey,
              JSON.stringify({ duration: this.duration, deadline: this.deadline })
            );
          } catch (error) {
            // Storage is optional. The timer still works for the current page view.
          }
        }

        const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        this.hoursElement.textContent = String(hours).padStart(2, '0');
        this.minutesElement.textContent = String(minutes).padStart(2, '0');
        this.secondsElement.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
